export class FloatLabel {
    public static bind($form: JQuery) {
        $form.find(".formcontrol:not(.textarea)").each((i, e) => {
            FloatLabel.bindCtrl($(e));
        });
    }

    public static bindCtrl($ctrl: JQuery) {
        const inpt = $ctrl
            .find("input")
            .focus((a) => {
                $(a.currentTarget).parents(".formcontrol").addClass("editing");
            })
            .blur((a) => {
                FloatLabel.addOrRemoveClasses($(a.currentTarget));
            });

        FloatLabel.addOrRemoveClasses(inpt);
    }

    public static check($form: JQuery) {
        $form.find(".formcontrol:not(.textarea) input").each((i, e) => {
            FloatLabel.addOrRemoveClasses($(e));
        });
    }

    private static addOrRemoveClasses($input: JQuery) {
        const par = $input.parents(".formcontrol").removeClass("editing");
        if (FloatLabel.numberFieldHasVal($input)) par.addClass("edited");
        else par.removeClass("edited");
    }

    public static numberFieldHasVal($numberField: JQuery) {
        let hasVal = $numberField.val().length !== 0;

        if ($numberField.attr("type") === "number" && hasVal === false) {
            if ($numberField[0]["validity"] !== undefined && $numberField[0]["validity"].badInput === true)
                hasVal = true;
        }

        return hasVal;
    }
}
